import { observer } from 'mobx-react-lite'
import { type DocumentPickerViewModel } from './DocumentPickerViewModel'
import { DocumentPicker } from '@/features/documents/DocumentPicker'
import { useInfiniteScroll } from '@/hooks/infinite-scroll-hooks'
import { useActivation } from '@/hooks/view-model-hooks'

export interface DocumentPickerContainerProps {
  vm: DocumentPickerViewModel
  searchPlaceholder?: string
  testId?: string
}

export const DocumentPickerContainer = observer(
  function DocumentPickerContainer({
    vm,
    searchPlaceholder,
    testId,
  }: DocumentPickerContainerProps) {
    useActivation(vm)
    const { connectRef } = useInfiniteScroll({ scroller: vm.scrollProvider })
    return (
      <DocumentPicker
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        focus$={vm.modal.showing$}
        searchText={vm.searchText}
        onSearchTextChange={vm.setSearchText}
        items={vm.documents.map((docVm) => ({
          id: docVm.document.id,
          title: docVm.document.title,
          fileName: docVm.fileName,
          isSelected: docVm.isSelected,
          isSelecting: docVm.select.pending,
          onSelect: docVm.select,
        }))}
        isDone={vm.scrollProvider.isDone}
        error={vm.fetch.rejected ? vm.fetch.error : undefined}
        scrollMonitorRef={connectRef}
        searchPlaceholder={searchPlaceholder}
        testId={testId}
      />
    )
  },
)
